import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import InfoIcon from "@material-ui/icons/Info";
import { IRoute } from "src/common/typings/routes";
import { GateEntery } from "./GateEntery";
import GateIn from "./pages/Gate-In/GateIn";
import { GateOut } from "./pages/Gate-Out";

export const GateEnteryRoute: IRoute = {
  title: "Gate Entry",
  path: "/gate-entry",
  icon: EmojiTransportationIcon,
  component: GateEntery,
  guard: true,
  subRoutes: [
    {
      icon: InfoIcon,
      component: GateIn,
      path: "/add-gate-entry",
      title: "Gate-In",
    },
    {
      component: GateIn,
      path: "/gate-entry-details",
      pathParam: "/:id",
      title: "Gate Entry Details",
      noDrawer: true,
    },
    {
      icon: InfoIcon,
      component: GateOut,
      path: "/gate-out",
      title: "Gate-Out",
    },
    {
      component: GateOut,
      path: "/gate-out-details",
      pathParam: "/:id",
      title: "Gate Out Details",
      noDrawer: true,
    },
  ],
};
